@let shoppingCart = shoppingCartStore.shoppingCart;
@let hasChanges = hasUnsavedChanges(shoppingCartForm) || hasTextFormChanges();
@if (shoppingCartStore.isLoading()) {
  <div class="pt-32">
    <aw-loading-animation></aw-loading-animation>
  </div>
}
@if (shoppingCart() && shoppingCartForm) {
  <div [formGroup]="languageForm" class="flex w-full justify-end">
    <aw-language-switcher
      formControlName="language"
      [label]="cmsTextProvider.shared.languageSelection"
      id="language-select">
      <div>{{ cmsTextProvider.shared.languageError }}</div>
    </aw-language-switcher>
  </div>
  <aw-section
    [isStickyHeader]="true"
    testIdAffix="shoppingCart"
    [formGroup]="shoppingCartForm">
    <aw-section-header>
      <aw-section-headline>{{
        cmsTextProvider.shared.shoppingCart
      }}</aw-section-headline>
      <aw-section-header-actions>
        <aw-button
          [id]="'private-save'"
          [style]="'primary'"
          [isDisabled]="!shoppingCartForm.valid || !hasChanges"
          (click)="save()"
          [type]="'submit'">
          {{ cmsTextProvider.shared.save }}
        </aw-button>
        <aw-button
          [id]="'private-cancel'"
          [style]="'primary-alt'"
          [type]="'reset'"
          [isDisabled]="!hasChanges"
          (click)="handleAbortChangesDialog()">
          {{ cmsTextProvider.shared.cancel }}
        </aw-button>
      </aw-section-header-actions>
    </aw-section-header>
    @if (shoppingCartStore.isLoading()) {
      <aw-loading-animation></aw-loading-animation>
    }
    @if (!shoppingCartStore.isLoading() && shoppingCartForm) {
      <aw-section
        id="section3-1"
        class="section"
        testIdAffix="vat"
        [isDisabled]="!shoppingCartForm.controls.showVat.value">
        <aw-section-header>
          <aw-section-headline>
            {{ cmsTextProvider.shared.vatRate }}.
          </aw-section-headline>
          <aw-section-header-actions>
            <aw-toggle
              formControlName="showVat"
              [label]="cmsTextProvider.shoppingCart.showVat"
              id="vatToggle">
            </aw-toggle>
          </aw-section-header-actions>
        </aw-section-header>
        @if (textStore.texts() && !textStore.isLoading()) {
          <aw-translation-text-input
            [entityType]="EntityType.shoppingCart"
            [attr.scroll-mark]="
              shoppingCartTextForm.value.shoppingCartPriceNetLabel?.[0]?.id
            "
            [relationType]="TextRelationType.shoppingCartPriceNetLabel"
            [label]="cmsTextProvider.shoppingCart.netPriceLabel"
            id="shoppingCartPriceNetLabel"
            [formControl]="
              shoppingCartTextForm.controls.shoppingCartPriceNetLabel
            "></aw-translation-text-input>
          <aw-translation-text-input
            [entityType]="EntityType.shoppingCart"
            [attr.scroll-mark]="
              shoppingCartTextForm.value.shoppingCartVatLabel?.[0]?.id
            "
            [relationType]="TextRelationType.shoppingCartVatLabel"
            [label]="cmsTextProvider.shoppingCart.vatRateLabel"
            id="shoppingCartVatLabel"
            [formControl]="
              shoppingCartTextForm.controls.shoppingCartVatLabel
            "></aw-translation-text-input>
        }
        @if (textStore.isLoading()) {
          <aw-loading-animation></aw-loading-animation>
        }
      </aw-section>
    }
  </aw-section>
}
